import { X, Check, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const BEFORE = [
    "Perfil confuso",
    "Comunicação inconsistente",
    "WhatsApp sem estrutura",
    "Informações dispersas",
    "Jornada do cliente pouco clara",
];

const AFTER = [
    "Presença profissional",
    "Comunicação clara",
    "WhatsApp organizado",
    "Informações estratégicas",
    "Jornada do cliente mais estruturada",
];

const Panel = ({ label, items, mode }) => {
    const isAfter = mode === "after";
    return (
        <div
            data-testid={`before-after-${mode}`}
            className={`h-full rounded-2xl p-8 sm:p-10 flex flex-col gap-8 ${
                isAfter
                    ? "border border-gold/40 bg-[#12120f] shadow-[0_0_60px_rgba(212,175,55,0.08)]"
                    : "border border-line bg-[#0d0d11]"
            }`}
        >
            <div className="flex items-center gap-4">
                <span
                    className={`font-mono2 text-[11px] uppercase tracking-[0.3em] ${
                        isAfter ? "text-gold" : "text-ink3"
                    }`}
                >
                    {label}
                </span>
                <span
                    className={`flex-1 h-px ${
                        isAfter
                            ? "bg-gradient-to-r from-gold/60 to-transparent"
                            : "bg-gradient-to-r from-line to-transparent"
                    }`}
                />
            </div>
            <ul className="flex flex-col gap-4">
                {items.map((item, i) => (
                    <li key={item} data-testid={`${mode}-item-${i + 1}`} className="flex items-center gap-3.5">
                        <span
                            className={`w-6 h-6 min-w-[24px] rounded-full border flex items-center justify-center ${
                                isAfter
                                    ? "border-gold/50 bg-gold/10 text-gold"
                                    : "border-line bg-bg2 text-ink3"
                            }`}
                        >
                            {isAfter ? <Check size={12} /> : <X size={12} />}
                        </span>
                        <span
                            className={`text-[15px] leading-relaxed ${isAfter ? "text-ink" : "text-ink3"}`}
                        >
                            {item}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

const BeforeAfter = () => (
    <section data-testid="before-after-section" className="py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeading
                eyebrow="Antes e depois"
                title={
                    <>
                        Não entregamos apenas conteúdo.
                        <br />
                        <span className="text-gold-grad">Entregamos estrutura.</span>
                    </>
                }
            />

            <div className="mt-14 grid lg:grid-cols-[1fr_auto_1fr] gap-6 lg:gap-8 items-stretch">
                <Reveal className="h-full">
                    <Panel label="Antes" items={BEFORE} mode="before" />
                </Reveal>
                <Reveal delay={0.1} className="flex lg:flex-col items-center justify-center">
                    <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-full border border-gold/40 bg-bg2 flex items-center justify-center text-gold rotate-90 lg:rotate-0 shadow-[0_0_30px_rgba(212,175,55,0.15)]">
                        <ArrowRight size={18} />
                    </div>
                </Reveal>
                <Reveal delay={0.15} className="h-full">
                    <Panel label="Depois" items={AFTER} mode="after" />
                </Reveal>
            </div>
        </div>
    </section>
);

export default BeforeAfter;
